import React from 'react';

import Flex from '@ui/Flex';
import Icon from '@ui/Icon';

import classes from './style.module.scss';

const content = {
  css: {
    globalVars: null,
    tips: (
      <Flex className={classes['BestPractices-list']} gap="xs" layout="col" tag="ul">
        <Flex align="center" gap="xs" justify="start" tag="li">
          <Icon color="green" name="check-circle" size={12} />
          <span>
            Use{' '}
            <a
              className={classes['BestPractices-link']}
              href="https://docs.readme.com/main/docs/customizing-docs-using-css-variables"
              rel="noreferrer"
              target="_blank"
            >
              CSS variables
              <Icon aria-label="Opens in new tab" color="color-text-minimum" name="arrow-up-right" size={12} />
            </a>
          </span>
        </Flex>
        <Flex align="center" gap="xs" justify="start" tag="li">
          <Icon color="green" name="check-circle" size={12} />
          <span>Use reserved classes, like .rm-Sidebar</span>
        </Flex>
      </Flex>
    ),
  },
  javascript: {
    globalVars: null,
    tips: (
      <Flex className={classes['BestPractices-list']} gap="xs" layout="col" tag="ul">
        <Flex align="start" gap="xs" justify="start" tag="li">
          <Icon color="green" name="check-circle" size={12} style={{ transform: 'translateY(2px)' }} />
          <Flex gap="xs" justify="start" layout="col" tag="li">
            Use the pageload event to run JavaScript on each page load:
            <code className={classes['BestPractices-code_block']}>
              <pre className={classes['BestPractices-pre']}>{"$(window).on('pageLoad', () => {});"}</pre>
            </code>
          </Flex>
        </Flex>
        <Flex align="center" gap="xs" justify="start" tag="li">
          <Icon color="color-text-minimum" name="help-circle" size={12} />
          <span>Your JavaScript is included before the closing body tag</span>
        </Flex>
      </Flex>
    ),
  },
};

export type BestPracticesContentType = keyof typeof content;

export const getContent = (type: BestPracticesContentType) => {
  return content[type];
};
